import { createFileRoute } from '@tanstack/react-router';

import { TryWhiteGloveView } from 'src/sections/white-glove/trial/try-white-glove-view';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/white-glove/try')({
  component: TryWhiteGlovePage,
});

function TryWhiteGlovePage() {
  const { orgId, clientId } = Route.useParams();
  return <TryWhiteGloveView orgId={orgId} clientId={clientId} />;
}
